import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { getTeamQueueCases } from '~/services/ContractingService';

import type { ContractingQueueCasesParams } from '~/types/services/contracting';

import { retryUnlessRejected } from './retryUnlessRejected';

export const caseQueueQueryKeys = {
  all: ['contracting', 'case-queues'] as const,
  queue: (teamKey: string, params: ContractingQueueCasesParams) =>
    [...caseQueueQueryKeys.all, teamKey, params] as const,
};

export function useGetTeamQueueCases(teamKey: string, params: ContractingQueueCasesParams) {
  return useQuery({
    queryKey: caseQueueQueryKeys.queue(teamKey, params),
    queryFn: ({ signal }) => getTeamQueueCases(teamKey, params, { signal }),
    placeholderData: keepPreviousData,
    retry: retryUnlessRejected,
  });
}
